module.exports = __webpack_public_path__ + "static/img/title_02@3x.c6ff85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/title_02@3x.png
// module id = hU9h
// module chunks = 1